import React, { useState, Fragment } from 'react';
import {
  IonList,
  IonLoading,
  IonSearchbar,
  IonContent,
  IonItem,
  IonLabel,
  IonChip,
  IonFab,
  IonFabButton,
  IonIcon,
  IonSelect,
  IonSelectOption
} from '@ionic/react';
import { refreshOutline } from 'ionicons/icons';
import { connect } from 'react-redux';
import * as actionCreator from '../store/actions/orderActions';
import _ from 'lodash';

import NoData from '../components/NoData';

export const OrdersContainer: React.FC = (props: any) => {
  const { list, updatedOrders, user } = props;
  const paidForItemsList = list.filter(
    (order: any) => order.paid === true && order.tx_ref
  );
  let filteredList = paidForItemsList;
  const [searchText, setSearchText] = useState<string>();

  if (updatedOrders === false) {
    props.onGetOrders(user.email);
    return <IonLoading isOpen={true} message={'Please wait...'} />;
  }

  if (searchText) {
    filteredList = paidForItemsList.filter((order: any) =>
      order.customerName.toLowerCase().includes(searchText.toLowerCase())
    );
  }

  setTimeout(() => {
    props.onResetStatus();
  }, 3000);

  // setTimeout(() => {
  //   props.onGetOrders(user.email);
  // }, 25000);

  return (
    <Fragment>
            
      <IonItem>
        <IonLabel>Showing</IonLabel>
        <IonSelect placeholder="Select One" value="all">
          <IonSelectOption value="all">All</IonSelectOption>
          <IonSelectOption value="pending">Pending</IonSelectOption>
          <IonSelectOption value="fulfilled">Fulfilled</IonSelectOption>
          <IonSelectOption value="cancelled">Cancelled</IonSelectOption>
        </IonSelect>
      </IonItem>
          
      <IonSearchbar
        className="search"
        value={searchText}
        onIonChange={(e) => setSearchText(e.detail.value!)}
      ></IonSearchbar>
      <IonContent>
        <IonList>
          {_.isEmpty(filteredList) && <NoData />}
          {filteredList.map((order: any) => (
            <IonItem key={order._id} routerLink={'/order/' + order._id}>
              <IonLabel>
                <h4>
                  <b>
                    <p>{order.customerName}</p>
                  </b>
                </h4>
                <h4>
                  <p>KES {order.amountPaid}</p>
                </h4>
                <p>{order.deliveryLocation}</p>
              </IonLabel>
              <IonChip
                slot="end"
                color={
                  order.cancelled
                    ? 'danger'
                    : order.fulfilled
                    ? 'success'
                    : 'primary'
                }
              >
                {order.cancelled
                  ? 'cancelled'
                  : order.fulfilled
                  ? 'Fulfilled'
                  : 'Pending'}
              </IonChip>
            </IonItem>
          ))}
        </IonList>
      </IonContent>
      {/*<IonFab vertical="top" horizontal="end" slot="fixed">
        <IonFabButton
          color="light"
          onClick={() => props.onGetOrders(user.email)}>
          <IonIcon icon={refreshOutline} />
        </IonFabButton>
        </IonFab>
      */}
    </Fragment>
  );
};

const mapStateToProps = (state: any) => {
  return {
    list: state.ordersReducer.list,
    updatedOrders: state.ordersReducer.updatedOrders,
    user: state.userReducer.user,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onResetStatus: () => dispatch(actionCreator.resetStatus()),
    onGetOrders: (payload: {}) => dispatch(actionCreator.getOrders(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrdersContainer);
